import React from "react";
import "../styles/_footer.scss";
import { Col, Nav, Row } from "react-bootstrap";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
// import YouTubeIcon from "@material-ui/icons/YouTube";
import GitHubIcon from "@material-ui/icons/GitHub";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter";
// import GoogleIcon from "@mui/icons-material/Google";
import EmailIcon from "@material-ui/icons/Email";

const Footer = () => {
  return (
    <div className="footer pb-5 pt-5 ">
      <div className="container">
        <Row className="justify-content-between align-items-center">
          <Col md={3} xs={12}>
            <div className="d-flex justify-content-between footer-info mt-4">
              <Nav.Link
                rel="noopener noreferrer"
                href="https://www.linkedin.com/in/tejassheth104/"
                className="nav-item cursor-pointer"
                aria-label="Linkedin"
                target="_blank"
              >
                <LinkedInIcon />
                {/* <img
                  src="https://icon.horse/icon/linkedin.com"
                  alt="LinkedIn"
                  width="30"
                  height="30"
                ></img> */}
              </Nav.Link>
              <Nav.Link
                rel="noopener noreferrer"
                href="https://github.com/TejasSheth104"
                className="nav-item cursor-pointer"
                target="_blank"
                aria-label="github"
              >
                <GitHubIcon />
                {/* <img
                  src="https://icon.horse/icon/github.com"
                  alt="GitHub"
                  width="30"
                  height="30"
                ></img> */}
              </Nav.Link>
              <Nav.Link
                rel="noopener noreferrer"
                href="mailto:tejas.sheth04@gmail.com"
                className="nav-item cursor-pointer"
                aria-label="Email"
                // target="_blank"
              >
                <EmailIcon />
                {/* <img src="https://icon.horse/icon/gmail.com"  alt="Email" width="30" height="30"></img> */}
              </Nav.Link>
              {/* <Nav.Link
                rel="noopener noreferrer"
                href="https://medium.com/@tejas.sheth04"
                className="nav-item cursor-pointer"
                target="_blank"
                aria-label="medium"
              >
                <img height="25px" src="images/med.png" alt="icon" /> */}
              {/* <img
                  src="https://icon.horse/icon/medium.com"
                  alt="Medium"
                  width="30"
                  height="30"
                ></img> */}
              {/* </Nav.Link> */}
              {/* <Nav.Link
                rel="noopener noreferrer"
                href="https://twitter.com/TejasSheth104"
                className="nav-item cursor-pointer"
                aria-label="Twitter"
                target="_blank"
              >
                <TwitterIcon /> */}
              {/* <img
                  src="https://icon.horse/icon/twitter.com"
                  alt="Twitter"
                  width="30"
                  height="30"
                ></img> */}
              {/* </Nav.Link> */}
              <Nav.Link
                rel="noopener noreferrer"
                href="https://www.instagram.com/tejassheth104/"
                className="nav-item cursor-pointer"
                aria-label="Instagram"
                target="_blank"
              >
                <InstagramIcon />
                {/* <img
                  src="https://icon.horse/icon/instagram.com"
                  alt="Instagram"
                  width="30"
                  height="30"
                ></img> */}
              </Nav.Link>
              {/* <Nav.Link
                  rel="noopener noreferrer"
                  href="https://www.hackerrank.com/amananku26"
                  className="nav-item cursor-pointer"
                  target="_blank"
                  aria-label="hackerrank"
                >
                  <img
                    height="25px"
                    src="images/hr.jpeg"
                    alt="icon"
                  />
                </Nav.Link> */}
              {/* <Nav.Link
                  rel="noopener noreferrer"
                  href="https://www.youtube.com/c/AmanAnku"
                  className="nav-item cursor-pointer"
                  target="_blank"
                  aria-label="Youtube"
                >
                  <YouTubeIcon/>
                </Nav.Link>
                <Nav.Link
                  rel="noopener noreferrer"
                  href="https://stackoverflow.com/users/14988771/aman-anku"
                  className="nav-item cursor-pointer"
                  target="_blank"
                  aria-label="stackoverflow"
                >
                  <img
                    height="25px"
                    src="images/so.png"
                    alt="icon"
                  />
                </Nav.Link>
                <Nav.Link
                  rel="noopener noreferrer"
                  href="https://opensea.io/coder26"
                  className="nav-item cursor-pointer"
                  target="_blank"
                  aria-label="stackoverflow"
                >
                  <img
                    height="25px"
                    src="https://styles.redditmedia.com/t5_4147ke/styles/communityIcon_lwl9gso33qk61.png"
                    alt="icon"
                  />
                </Nav.Link> */}
            </div>
          </Col>
          <Col md={5} xs={12}>
            <ul className="d-flex justify-content-between p-0 w-100 footer-info mt-4 ">
              {/* <li className="p-1">
                <a rel="noopener noreferrer" href="#home">
                  Home
                </a>
              </li> */}
              <li className="p-1">
                <a rel="noopener noreferrer" href="#about">
                  About
                </a>
              </li>
              <li className="p-1">
                <a rel="noopener noreferrer" href="#experience">
                  Skills
                </a>
              </li>
              <li className="p-1">
                <a rel="noopener noreferrer" href="#skills">
                  Skills
                </a>
              </li>
              <li className="p-1">
                <a rel="noopener noreferrer" href="#projects">
                  Projects
                </a>
              </li>
              <li className="p-1">
                <a rel="noopener noreferrer" href="#publications">
                  Publications
                </a>
              </li>
              <li className="p-1">
                <a rel="noopener noreferrer" href="#contact">
                  Contact
                </a>
              </li>
            </ul>
          </Col>
        </Row>
        <div className="text-center mt-4  footer-end">
          <p>
            Made with ❤️ by{" "}
            <span className="chonburi-font green-text"> Tejas Sheth</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
